import { render, staticRenderFns } from "./ShowJob.vue?vue&type=template&id=21c85333&scoped=true"
import script from "./ShowJob.vue?vue&type=script&lang=js"
export * from "./ShowJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c85333",
  null
  
)

export default component.exports